import React from 'react';
import CallToAction from 'components/Contentful/ContentfulCallToAction';

const ContentfulCallToActionColumnWrapper = (item) => {
  return <CallToAction {...item} />;
};

export default ContentfulCallToActionColumnWrapper;
